export enum P2pModalType {
  single = 'single',
  group = 'group',
}
